<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">FIGHTING NAPOLEON AT HOME</p>
<a id="page_ii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle.vue?fbb41054